import React from 'react'
import { SvgIcon, SvgIconProps } from '@hermes/web-components'

const defaultColor = '#2C3341'

const CreditCardIcon = ({ color, ...props }: SvgIconProps) => (
  <SvgIcon width="22" height="23" viewBox="0 0 22 23" {...props}>
    <path
      d="M19.25 3.74829H2.74996C1.73744 3.74829 0.916626 4.5691 0.916626 5.58162V16.5816C0.916626 17.5941 1.73744 18.415 2.74996 18.415H19.25C20.2625 18.415 21.0833 17.5941 21.0833 16.5816V5.58162C21.0833 4.5691 20.2625 3.74829 19.25 3.74829Z"
      stroke={color || defaultColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M0.916626 9.24829H21.0833"
      stroke={color || defaultColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </SvgIcon>
)

export default CreditCardIcon
